import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  DISCOUNT_SALES_TABLE_LIST,
  TOP_DISCOUNTS_BY_AMOUNT,
  TOP_SALE_DISCOUNT_LIST,
} from "../../../../Constants/Config";

// PHP-backed twin of discountSalesReportSlice, and the one the default
// "Discounts Report" screen reads - the fact-table slice is behind ?source=new.
// This keeps the three original PHP calls (discount_sales_report_list,
// top_sale_discount_sold and top_discounts_by_amount, all on BASE_URL); the
// fact-table slice collapses them into one request.
const initialState = {
  loading: false,
  discountSalesData: {},
  topDiscounts: {},
  topDiscountsByAmount: {},
  status: false,
  successMessage: "",
  error: "",
};

let cancelTokenSource;
let cancelTokenSource1;
let cancelTokenSource2;

export const fetchDiscountSalesOld = createAsyncThunk(
  "discountSalesReportOldSlice/fetchDiscountSalesOld",
  async (data, { rejectWithValue }) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }

    // Create a new cancel token
    cancelTokenSource = axios.CancelToken.source();

    try {
      const { token, ...dataNew } = data;
      const res = await axios.post(
        BASE_URL + DISCOUNT_SALES_TABLE_LIST,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource.token,
        }
      );
      if (res.data.status === true) {
        const data = res.data.discount_data;
        const status = res.data.status;
        return { data, status };
      } else if (res.data.status === false) {
        const data = null;
        const status = false;
        return { data, status };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchTopDiscountsOld = createAsyncThunk(
  "discountSalesReportOldSlice/fetchTopDiscountsOld",
  async (data, { rejectWithValue }) => {
    if (cancelTokenSource1) {
      cancelTokenSource1.cancel("Previous request canceled");
    }

    // Create a new cancel token
    cancelTokenSource1 = axios.CancelToken.source();

    try {
      const { token, ...dataNew } = data;
      const res = await axios.post(BASE_URL + TOP_SALE_DISCOUNT_LIST, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        cancelToken: cancelTokenSource1.token,
      });
      if (res.data.status === true) {
        const data = res.data.discount_data;
        return { data };
      } else if (res.data.status === false) {
        return {};
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchTopDiscountsByAmountOld = createAsyncThunk(
  "discountSalesReportOldSlice/fetchTopDiscountsByAmountOld",
  async (data, { rejectWithValue }) => {
    if (cancelTokenSource2) {
      cancelTokenSource2.cancel("Previous request canceled");
    }

    // Create a new cancel token
    cancelTokenSource2 = axios.CancelToken.source();
    try {
      const { token, ...dataNew } = data;
      const res = await axios.post(
        BASE_URL + TOP_DISCOUNTS_BY_AMOUNT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource2.token,
        }
      );
      if (res.data.status === true) {
        const data = res.data.discount_data;
        return { data };
      } else if (res.data.status === false) {
        return {};
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const discountSalesReportOldSlice = createSlice({
  name: "discountSalesReportOldSlice",
  initialState,
  reducers: {
    updateStateOfDiscountOld: (state) => {
      state.discountSalesData = {};
      state.topDiscounts = {};
      state.topDiscountsByAmount = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDiscountSalesOld.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchDiscountSalesOld.fulfilled, (state, action) => {
      state.loading = false;
      state.discountSalesData = action.payload?.data;
      state.status = action.payload?.status;
      state.error = "";
    });
    builder.addCase(fetchDiscountSalesOld.rejected, (state, action) => {
      state.loading = false;
      state.discountSalesData = {};
      state.error = action.error.message;
    });

    builder.addCase(fetchTopDiscountsOld.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTopDiscountsOld.fulfilled, (state, action) => {
      state.loading = false;
      state.topDiscounts = action.payload?.data;
      state.error = "";
    });
    builder.addCase(fetchTopDiscountsOld.rejected, (state, action) => {
      state.loading = false;
      state.topDiscounts = {};
      state.error = action.error.message;
    });

    builder.addCase(fetchTopDiscountsByAmountOld.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTopDiscountsByAmountOld.fulfilled, (state, action) => {
      state.loading = false;
      state.topDiscountsByAmount = action.payload?.data;
      state.error = "";
    });
    builder.addCase(fetchTopDiscountsByAmountOld.rejected, (state, action) => {
      state.loading = false;
      state.topDiscountsByAmount = {};
      state.error = action.error.message;
    });
  },
});

export const { updateStateOfDiscountOld } = discountSalesReportOldSlice.actions;
export default discountSalesReportOldSlice.reducer;
